import MetaTags from "./MetaTags";

export const Error404 = () => {
  return (
    <div className="px-10 lg:px-40 xl:px-56 pb-10 pt-6">
      Error 404 Page Not Found
    </div>
  );
};
